import {action, observable, makeObservable} from 'mobx';
import {DesignField} from '../../../stores/DesignField';
import {ColumnsDesignCollection} from './ColumnsDesignCollection';

export class ColumnsDesignField extends DesignField {
    @observable cover;

    constructor(field, parentField) {
        super(field, parentField);
        makeObservable(this);
        this.cover = field.cover;
        this.collection = new ColumnsDesignCollection(parentField.collection);
    }

    setCollection(field) {
        field.fields && this.collection.insertFields(this, field.fields);
    }

    @action setCover(value) {
        this.cover = value;
    }
}
